import React, { useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import axios from "axios";
import { jwttoken } from "../../../environment";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";
import Loader from "../../../core/common/selfLoder";

interface JobRefData {
  ID: number;
  name: string;
  email: string;
  phone: string;
  year_of_experience: string;
  position: string;
  resume: string;
  referred_by: string;
  status: string;
  created_date: string;
}
interface JobRefResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: JobRefData[];
}
const JobRefferalList = () => {
  const [shouldRefetch, setShouldRefetch] = useState(1);
  const [seletctRow, setSelectedRow] = useState<any>(null);

  const {
    data: response,
    loading: jobrefLoading,
    error: jobreferror,
  } = useApi<JobRefResponse>("/api/reffered-friend-list", {
    method: "GET",
    autoCall: true,
    dependencies: [shouldRefetch],
  });

  const data = response?.data.map((item: any, index: number) => ({
    ...item,
    Sno: index + 1,
  }));

  console.log(data);
  const columns = [
    {
      title: "SNo.",
      dataIndex: "Sno",
    },
    {
      title: "Referral Id",
      dataIndex: "ID",
      sorter: (a: any, b: any) => a.ID - b.ID,
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (text: string, record: JobRefData) => (
        <div className="d-flex align-items-center file-name-icon">
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to="#">{record.name}</Link>
            </h6>
            <span className="d-block mt-1">{record.email}</span>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
    },
    {
      title: "Position",
      dataIndex: "position",
      sorter: (a: any, b: any) => a.position.localeCompare(b.position),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      sorter: (a: any, b: any) => a.phone.localeCompare(b.phone),
    },
    {
      title: "Experience",
      dataIndex: "year_of_experience",
      render: (text: string) => `${text} Years`,
      sorter: (a: any, b: any) =>
        parseFloat(a.year_of_experience) - parseFloat(b.year_of_experience),
    },
    {
      title: "Resume",
      dataIndex: "resume",
      render: (text: string) => (
        <a
          href={text}
          target="_blank"
          rel="noopener noreferrer"
          className="d-flex align-items-center"
        >
          <i
            className="ti ti-file-description me-2"
            style={{ color: "#e74c3c", fontSize: "18px" }}
          ></i>
          View Resume
        </a>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        <span
          className={`badge ${text === "Active"
            ? "bg-success"
            : text === "Inactive"
              ? "bg-secondary"
              : "bg-warning"
            }`}
        >
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
    },

    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#editModal"
            onClick={() => setSelectedRow(record)}
          >
            <i className="ti ti-edit" />
          </Link>
          <Link
            to="#"
            data-bs-toggle="modal"
            data-bs-target="#delete_modal_ref_job"
            onClick={() => {
              setSelectedRow(record);
            }}
          >
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];

  const {
    data: deleteResponse,
    loading: isDeleting,
    error: deleteError,
    callApi: callDeleteApi,
  } = useApi("/api/delete-job-reffered", {
    method: "DELETE",
    autoCall: false,
  });

  const deleteRecord = async () => {
    try {
      const response = await callDeleteApi({ refferal_id: seletctRow?.ID });
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Job Referral Deleted",
          text: "The job referral has been successfully deleted.",
        });
        setShouldRefetch(shouldRefetch + 1);
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        Swal.fire({
          title: "Error!",
          text:
            error.response?.data?.message || "An unexpected error occurred.",
          icon: "error",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "An unexpected error occurred.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };

  return (
    <>
      <Loader loading={jobrefLoading} />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">My Job Referrals </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Career & Support</li>
                  <li className="breadcrumb-item">Open Positions (Jobs)</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    My Job Referrals
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Referrals List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                {/* <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Role
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Senior IOS Developer
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Junior PHP Developer
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Network Engineer
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By : Last 7 Days
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Desending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                dataSource={data || []}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      {/* /Modal */}

      <div
        className="modal fade"
        id="editModal"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Referral</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form>
                {/* Name */}
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">
                    <strong>Name:</strong>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    value={seletctRow?.name}
                    placeholder="Enter Full Name"
                    required
                  />
                </div>

                {/* Email */}
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    <strong>Email ID:</strong>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    value={seletctRow?.email}
                    placeholder="Enter Email ID"
                    required
                  />
                </div>

                {/* Phone Number */}
                <div className="mb-3">
                  <label htmlFor="phone" className="form-label">
                    <strong>Phone No.:</strong>
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    id="phone"
                    name="phone"
                    value={seletctRow?.phone}
                    placeholder="Enter Phone No."
                    required
                  />
                </div>

                {/* Years of Experience */}
                <div className="mb-3">
                  <label htmlFor="experience" className="form-label">
                    <strong>Years of Experience:</strong>
                  </label>
                  <select
                    className="form-select"
                    id="experience"
                    name="experience"
                    value={seletctRow?.year_of_experience}
                    required
                  >
                    <option value="">Select Experience</option>
                    <option value="1-2">1-2</option>
                    <option value="2-3">2-3</option>
                    <option value="3-4">3-4</option>
                    <option value="4-5">4-5</option>
                    <option value="5-6">5-6</option>
                    <option value="6-7">6-7</option>
                    <option value="7-8">7-8</option>
                    <option value="8-9">8-9</option>
                    <option value="9-10">9-10</option>
                    <option value="10-11">10-11</option>
                    <option value="11-12">11-12</option>
                    <option value="12-13">12-13</option>
                    <option value="13-14">13-14</option>
                    <option value="14-15">14-15</option>
                  </select>
                </div>

                {/* Position */}
                <div className="mb-3">
                  <label htmlFor="position" className="form-label">
                    <strong>Position:</strong>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="position"
                    name="position"
                    value={seletctRow?.position}
                    placeholder="Enterprise Sales Manager"
                    disabled
                  />
                </div>

                {/* Resume Upload */}
                <div className="mb-3">
                  <label htmlFor="resume" className="form-label">
                    <strong>Upload Resume:</strong>
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="resume"
                    name="resume"
                    accept=".pdf"
                    required
                  />
                  <small className="text-muted">
                    Upload PDF only and size should be less than or equal to 2
                    MB
                  </small>
                </div>

                {/* Submit Button */}
                <div className="mb-3 text-center">
                  <button type="submit" className="btn btn-primary custom_button">
                    Update Job Referral Details
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* /Modal */}

      <div className="modal fade" id="delete_modal_ref_job">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <span className="avatar avatar-xl bg-transparent-danger text-danger mb-3">
                <i className="ti ti-trash-x fs-36" />
              </span>
              <h4 className="mb-1">Confirm Delete</h4>
              <p className="mb-3">
                Are you sure you want to delete this job referral? This action
                cannot be undone.
              </p>
              <div className="d-flex justify-content-center">
                <Link
                  to="#"
                  className="btn btn-light me-3"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </Link>
                <Link
                  to="#"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={() => deleteRecord()}
                >
                  Yes, Delete
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobRefferalList;
